import { createFileRoute } from "@tanstack/react-router";
import { useScrollToAnchor } from "@/features/settings/hooks/use-scroll-to-anchor";
import { useCurrentOrg, useIsOrgAdmin } from "@/stores";
import { KGRuntimeLimitsCard } from "@/features/settings/advanced/components/kg-runtime-limits-card";

function AdvancedSection() {
  useScrollToAnchor();
  const org = useCurrentOrg();
  const canEdit = useIsOrgAdmin();
  return (
    <div className="max-w-2xl">
      <KGRuntimeLimitsCard orgId={org?.id ?? ""} canEdit={canEdit} />
    </div>
  );
}

export const Route = createFileRoute("/_admin/settings/advanced")({
  component: AdvancedSection,
});
